import { ChartType } from '@/pages/datalab/core/chart';
import ChartTableIcon from '@/pages/aigc/assets/svg/chart-table.svg';
import ChartLineIcon from '@/pages/aigc/assets/svg/chart-line.svg';
import ChartBarIcon from '@/pages/aigc/assets/svg/chart-bar.svg';
import ChartStackBarIcon from '@/pages/aigc/assets/svg/chart-stack-bar.svg';
import ChartPercentStackBarIcon from '@/pages/aigc/assets/svg/chart-percent-stack-bar.svg';
import ChartBigNumberIcon from '@/pages/aigc/assets/svg/chart-big-number.svg';
import ChartMapIcon from '@/pages/aigc/assets/svg/chart-map.svg';
import ChartWordCloudIcon from '@/pages/aigc/assets/svg/chart-word-cloud.svg';
import ChartMixedIcon from '@/pages/aigc/assets/svg/chart-mixed.svg';
import ChartAreaIcon from '@/pages/aigc/assets/svg/chart-area.svg';
import ChartVerticalDivergingBarIcon from '@/pages/aigc/assets/svg/chart-vertical-diverging-bar.svg';
import ChartHorizontalDivergingBarIcon from '@/pages/aigc/assets/svg/chart-horizontal-diverging-bar.svg';
import ChartPieIcon from '@/pages/aigc/assets/svg/chart-pie.svg';
import ChartHorizontalBarIcon from '@/pages/aigc/assets/svg/chart-horizontal-bar.svg';
/**
 * ChartType 枚举值 → SVG icon 路径映射
 *
 * 缺失专用 icon（当前 fallback 占位，待设计补齐）：
 * - GroupBarChart（分组柱图）—— 用 chart-bar 占位
 * - EventLineChart（事件折线图）—— 用 chart-line 占位
 */
export const CHART_TYPE_ICON_MAP: Record<string, string> = {
  // 表格
  [ChartType.Table]: ChartTableIcon,
  // 地图
  [ChartType.Map]: ChartMapIcon,
  // 折线图
  [ChartType.Line]: ChartLineIcon,
  // 事件折线图（TODO: 缺专用 icon，暂用折线图占位）
  [ChartType.EventLine]: ChartLineIcon,
  // 柱状图
  [ChartType.Bar]: ChartBarIcon,
  // 堆叠柱图
  [ChartType.StackBar]: ChartStackBarIcon,
  // 百分比堆叠图
  [ChartType.PercentStackBar]: ChartPercentStackBarIcon,
  // 数字卡片
  [ChartType.BigNumber]: ChartBigNumberIcon,
  // 趋势图
  [ChartType.Trend]: ChartBigNumberIcon,
  // 分维度趋势卡片
  [ChartType.DimNumberTrend]: ChartBigNumberIcon,
  // 条形图
  [ChartType.HorizontalBarChart]: ChartHorizontalBarIcon,
  // 组合图
  [ChartType.MixedChart]: ChartMixedIcon,
  // 词云图
  [ChartType.WordCloud]: ChartWordCloudIcon,
  // 饼图
  [ChartType.Pie]: ChartPieIcon,
  // 矩形面积图（前端枚举暂无对应字段，按后端约定字符串先就位）
  AreaChart: ChartAreaIcon,
  // 上下正负柱状图
  VerticalDivergingBarChart: ChartVerticalDivergingBarIcon,
  // 左右正负柱状图
  HorizontalDivergingBarChart: ChartHorizontalDivergingBarIcon,
};

/** 基于后端传入的 chart type 获取 icon */
export const getChartTypeIcon = (type?: string, fallbackIcon?: string): string | undefined => {
  if (!type) return fallbackIcon;
  return CHART_TYPE_ICON_MAP[type] || fallbackIcon;
};
